import React from 'react';

/**
 * Floating card on the map showing subject property details at a glance.
 */
const SubjectPropertyCard = ({ address, coords, sensorCount, competitorCount, nearestSensor }) => {
  const nearestAadt = nearestSensor?.latest_aadt;
  const nearestDist = nearestSensor?.distance_meters;
  const nearestRoad = nearestSensor?.road_type || nearestSensor?.station_id;

  return (
    <div style={{
      position: 'absolute',
      top: 12,
      left: 12,
      background: 'rgba(255,255,255,0.97)',
      backdropFilter: 'blur(10px)',
      borderRadius: 14,
      padding: '16px 18px',
      color: '#1f2937',
      fontSize: 13,
      fontFamily: 'system-ui, sans-serif',
      zIndex: 12,
      boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
      border: '2px solid #3b82f6',
      maxWidth: 280,
      lineHeight: 1.6,
    }}>
      <div style={{
        fontWeight: 800,
        fontSize: 14,
        color: '#1e40af',
        marginBottom: 8,
        borderBottom: '2px solid #3b82f6',
        paddingBottom: 6,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
      }}>
        <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 24,
          height: 24,
          borderRadius: '50%',
          background: '#3b82f6',
          color: '#fff',
          fontSize: 12,
        }}>📍</span>
        Subject Property
      </div>

      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6, color: '#111827' }}>
        {address || 'Address not available'}
      </div>

      {coords?.lat && (
        <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 10 }}>
          {Number(coords.lat).toFixed(6)}, {Number(coords.lng).toFixed(6)}
        </div>
      )}

      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '6px 12px',
        fontSize: 12,
        borderTop: '1px solid #e5e7eb',
        paddingTop: 10,
      }}>
        <div>
          <div style={{ color: '#6b7280', fontSize: 10, textTransform: 'uppercase' }}>Sensors</div>
          <div style={{ fontWeight: 700, color: '#059669' }}>{sensorCount || 0}</div>
        </div>
        <div>
          <div style={{ color: '#6b7280', fontSize: 10, textTransform: 'uppercase' }}>Competitors</div>
          <div style={{ fontWeight: 700, color: '#dc2626' }}>{competitorCount || 0}</div>
        </div>
      </div>

      {nearestAadt && (
        <div style={{
          marginTop: 10,
          padding: '8px 10px',
          background: '#f0f9ff',
          borderRadius: 8,
          border: '1px solid #bfdbfe',
          fontSize: 12,
        }}>
          <div style={{ fontWeight: 700, color: '#1e40af', marginBottom: 2 }}>
            📡 Nearest Road
          </div>
          <div>{nearestRoad}</div>
          <div>
            <b>{nearestAadt.toLocaleString()}</b> AADT
            {nearestDist ? ` · ${Math.round(nearestDist)} m away` : ''}
          </div>
        </div>
      )}
    </div>
  );
};

export default SubjectPropertyCard;
